/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ced299804fb01385fefefbab429e216>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "QuotationBlock".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/quotation-block
 * Usage guidance:
 * Preferred for representing block quotes and quote text style in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const QuotationBlockIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "QuotationBlockIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" d="M9.5 9a2 2 0 0 1 2 2v2.94c0 .59-.48 1.06-1.06 1.06H9.06A1.06 1.06 0 0 1 8 13.94v-1.38c0-.59.48-1.06 1.06-1.06H10V11a.5.5 0 0 0-.5-.5H9V9zM6.94 1C7.52 1 8 1.48 8 2.06v1.37c0 .59-.48 1.07-1.06 1.07H6V5a.5.5 0 0 0 .5.5H7V7h-.5a2 2 0 0 1-2-2V2.06C4.5 1.48 4.98 1 5.56 1zM14 9a2 2 0 0 1 2 2v2.94c0 .59-.48 1.06-1.06 1.06h-1.38a1.06 1.06 0 0 1-1.06-1.06v-1.38c0-.59.48-1.06 1.06-1.06h.94V11a.5.5 0 0 0-.5-.5h-.5V9zM2.44 1c.58 0 1.06.48 1.06 1.06v1.37c0 .59-.48 1.06-1.06 1.06H1.5V5a.5.5 0 0 0 .5.5h.5V7H2a2 2 0 0 1-2-2V2.06C0 1.48.48 1 1.06 1z"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
QuotationBlockIcon.displayName = 'QuotationBlockIcon';
var _default = exports.default = QuotationBlockIcon;